import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function GoRedirect() {
  const { slug } = useParams();
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/go/${slug}`);
  }, [slug]);
  return (
    <div className="min-h-screen bg-black flex items-center justify-center" data-testid="go-redirect-page">
      <p className="text-zinc-500 text-sm">Redirecting…</p>
    </div>
  );
}
